import { Card, Progress, Space, Typography } from "antd";
import React, { ReactNode } from "react";
const { Title } = Typography;

interface Props {
    title: string;
    progress: number;
}


const ProgressCard: React.FC<Props> = ({
    title,
    progress }) => {

    return <Card>
        <Space direction="vertical" align="center" style={{ width: '100%' }}>
            <Title level={5}>
                {title}
            </Title>
            <Progress
                type="circle"
                percent={progress}
                size={"default"}
            />
        </Space>
    </Card>
}

export default ProgressCard;